export const useConfigStore = defineStore(
  'configStore',
  () => {
    const queries = ref<Record<string, object>>({})

    const retainQueriesForRoute = (routePath: string) => {
      const normalizedRoutePath = routePath.replace(/^\/+|\/+$/g, '')

      for (const landingPath of Object.keys(queries.value)) {
        const normalizedLandingPath = landingPath.replace(/^\/+|\/+$/g, '')
        const isRelatedRoute =
          normalizedRoutePath === normalizedLandingPath ||
          normalizedRoutePath.startsWith(`${normalizedLandingPath}/`)

        if (!isRelatedRoute) {
          delete queries.value[landingPath]
        }
      }
    }

    return { queries, retainQueriesForRoute }
  },
  {
    persist: {
      storage: import.meta.client ? sessionStorage : undefined,
      pick: ['queries'],
    },
  }
)
